module.exports = __webpack_public_path__ + "img/farzana-christopher-124.92ad76de.jpg";